import { render, staticRenderFns } from "./DfmCheck.vue?vue&type=template&id=771fc05a&"
import script from "./DfmCheck.vue?vue&type=script&lang=js&"
export * from "./DfmCheck.vue?vue&type=script&lang=js&"
import style0 from "./DfmCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports